var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4.07,
    fill: "#4B57E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4.07,
    fill: "url(#paint0_linear_664_33902)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0049 20.9951C23.0049 21.1277 22.9522 21.2549 22.8584 21.3487C22.7647 21.4424 22.6375 21.4951 22.5049 21.4951H10.5049C10.3723 21.4951 10.2451 21.4424 10.1513 21.3487C10.0576 21.2549 10.0049 21.1277 10.0049 20.9951V10.9951C10.0049 10.8625 10.0576 10.7353 10.1513 10.6416C10.2451 10.5478 10.3723 10.4951 10.5049 10.4951C10.6375 10.4951 10.7647 10.5478 10.8584 10.6416C10.9522 10.7353 11.0049 10.8625 11.0049 10.9951V17.7882L14.1511 14.6414C14.1976 14.5949 14.2527 14.558 14.3134 14.5328C14.3741 14.5077 14.4392 14.4947 14.5049 14.4947C14.5706 14.4947 14.6357 14.5077 14.6964 14.5328C14.7571 14.558 14.8122 14.5949 14.8586 14.6414L16.5049 16.2882L19.798 12.9951H18.5049C18.3723 12.9951 18.2451 12.9424 18.1513 12.8487C18.0576 12.7549 18.0049 12.6277 18.0049 12.4951C18.0049 12.3625 18.0576 12.2353 18.1513 12.1416C18.2451 12.0478 18.3723 11.9951 18.5049 11.9951H21.0049C21.1375 11.9951 21.2647 12.0478 21.3584 12.1416C21.4522 12.2353 21.5049 12.3625 21.5049 12.4951V14.9951C21.5049 15.1277 21.4522 15.2549 21.3584 15.3487C21.2647 15.4424 21.1375 15.4951 21.0049 15.4951C20.8723 15.4951 20.7451 15.4424 20.6513 15.3487C20.5576 15.2549 20.5049 15.1277 20.5049 14.9951V13.702L16.8586 17.3489C16.8122 17.3954 16.7571 17.4322 16.6964 17.4574C16.6357 17.4826 16.5706 17.4955 16.5049 17.4955C16.4392 17.4955 16.3741 17.4826 16.3134 17.4574C16.2527 17.4322 16.1976 17.3954 16.1511 17.3489L14.5049 15.702L11.0049 19.202V20.4951H22.5049C22.6375 20.4951 22.7647 20.5478 22.8584 20.6416C22.9522 20.7353 23.0049 20.8625 23.0049 20.9951Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_33902",
    x1: 16.5,
    y1: 0,
    x2: 16.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B57E2",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.1fc427f86c197500931736472c9791b9.svg";
export { ForwardRef as ReactComponent };